import React from 'react';
import { generateModifierClasses } from "../../modules/utils";
export default function Link({ href = '#', modifiers, target, children }) { return /*#__PURE__*/ React.createElement("a", { className: generateModifierClasses('link', modifiers), href: href, target: target }, children); }
